import React, { createContext, useContext, useMemo } from "react";
import { UserType } from "../../types/user";

type UserContextType = {
  user: UserType;
};

const UserContext = createContext({} as UserContextType);

export const useUser = () => useContext(UserContext);

type UserContextProviderProps = {
  children: React.ReactNode;
  user: UserType;
};

export const UserContextProvider = ({
  children,
  user,
}: UserContextProviderProps) => {
  const contextValue = useMemo(() => ({ user }), [user]);
  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};
